// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-screen[data-v-583edec2]{min-height:100vh}.h-half-screen[data-v-583edec2]{min-height:calc(100vh - 240px)}.pt-17[data-v-583edec2]{padding-top:66px}.mb-18[data-v-583edec2]{padding-bottom:78px}@media(min-width:960px){.px-md-30[data-v-583edec2]{padding-right:25vw!important;padding-left:25vw!important}}.border-outline[data-v-583edec2]{border:none;outline:.5px solid rgba(0,0,0,.12)!important}", ""]);
// Exports
module.exports = exports;
